export const environment = {
  production: false,
  qa: true,
  apiUrl: 'https://labase-qa-api.apiba.fr',
  n8nWebhookUrl: 'https://178.23.154.52:8081/webhook/labase/trigger/dispos'
};
